export default __webpack_public_path__ + "static/media/thumb-frame.46f53bab.png";